var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera_alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6665 4.50602H14.0248L12.4998 2.83936H7.49984L5.97484 4.50602H3.33317C2.4165 4.50602 1.6665 5.25602 1.6665 6.17269V16.1727C1.6665 17.0894 2.4165 17.8394 3.33317 17.8394H16.6665C17.5832 17.8394 18.3332 17.0894 18.3332 16.1727V6.17269C18.3332 5.25602 17.5832 4.50602 16.6665 4.50602ZM16.6665 16.1727H3.33317V6.17269H6.70817L8.23317 4.50602H11.7665L13.2915 6.17269H16.6665V16.1727ZM9.99984 7.00602C7.69984 7.00602 5.83317 8.87269 5.83317 11.1727C5.83317 13.4727 7.69984 15.3394 9.99984 15.3394C12.2998 15.3394 14.1665 13.4727 14.1665 11.1727C14.1665 8.87269 12.2998 7.00602 9.99984 7.00602ZM9.99984 13.6727C8.62484 13.6727 7.49984 12.5477 7.49984 11.1727C7.49984 9.79769 8.62484 8.67269 9.99984 8.67269C11.3748 8.67269 12.4998 9.79769 12.4998 11.1727C12.4998 12.5477 11.3748 13.6727 9.99984 13.6727Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoto);
export default __webpack_public_path__ + "static/media/ic_photo.321cdee313c95d02eff9a9c337522eef.svg";
export { ForwardRef as ReactComponent };